import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "price-and-button d-flex align-items-center justify-content-between gap-3" }
const _hoisted_2 = { class: "price-details text-start heading fw-bold flex-grow-1" }
const _hoisted_3 = { class: "caption mt-1" }

import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import store from '@/store'

  // Config
  import { ModalId } from '@/config/modalIds'

  // Components
  import ViewDetailsButton from '@/components/common/ViewDetailsButton.vue'
  import Price from '@/components/common/Price.vue'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'PriceAndViewDetailsButton',
  props: {
    isReservation: {
      type: Boolean,
      required: true,
    },
    booking: {
      type: Object,
      required: true,
    },
  },
  setup(__props) {

  const props = __props

  const { t, n } = useI18n()

  const buttonStyle = computed(() =>
    props.isReservation
      ? 'button-secondary secondary-normal small flex-grow-1 action-button'
      : 'button-primary primary-normal small flex-grow-1'
  )

  const handleOpenPanel = () => {
    store.dispatch('booking/selectBooking', props.booking)
    store.commit('modal/open', ModalId.BOOKING_PANEL)
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Price, {
        price: __props.booking.sellingPrice
      }, null, 8, ["price"]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('reservations.FeeIncluded')), 1)
    ]),
    _createVNode(ViewDetailsButton, {
      booking: props.booking,
      buttonStyle: buttonStyle.value,
      onViewDetails: handleOpenPanel
    }, null, 8, ["booking", "buttonStyle"])
  ]))
}
}

})